function inserted (el, binding, vnode) {
  el.classList.add(`${binding.name}-${binding.value}`)
}

export default{
  name: 'elevation',
  inserted
}



// WEBPACK FOOTER //
// ./src/directivies/elevation.js